// Avatar — DRY: the navy initials circle used beside a person's name.
import { getInitials } from "../../lib/initials.js";

const SIZE_CLASSES = {
  sm: "h-8 w-8 text-xs",
  md: "h-11 w-11 text-sm",
} as const;

interface AvatarProps {
  name: string;
  size?: keyof typeof SIZE_CLASSES;
}

export default function Avatar({ name, size = "sm" }: AvatarProps) {
  return (
    <div className={`flex shrink-0 items-center justify-center rounded-full bg-dm-navy font-semibold text-white ${SIZE_CLASSES[size]}`}>
      {getInitials(name)}
    </div>
  );
}
